import React, { FunctionComponent, useState } from 'react'
import styles from './SearchFilters.module.sass'
import Spacer from '../../../etc/Spacer'
import Field from '../../../controls/Field/Field'
import SearchIcon from 'files/search.svg'
import Splitter from '../../../etc/Splitter/Splitter'
import { apiRequests } from '../../../../http/config'
import { RefIntersection } from '../../../../responses/refs/refs'
import Button, { ButtonStyle } from '../../../controls/Button/Button'
import FiltersIcon from '../../../../../files/filters.svg'
import FiltersClearIcon from '../../../../../files/filters-clear.svg'
import { isDefinedRecord, isDefinedTuple } from '../../../../utils/utils'
import { useRootDispatch, useRootSelector } from '../../../../utils/hooks'
import { searchActions } from '../../../../redux/pages/search'
import PopupFilters from '../../projects/ProjectList/ProjectFilters/ProjectFiltersDesktop/PopupFilters'
import { flow } from 'fp-ts/function'
import { Classes } from '../../../../styles'
import { refsConfig } from '../../projects/ProjectList/ProjectFilters/filters'
import RequestDropdown from '../../../data-components/dropdowns/RequestDropdown/RequestDropdown'
import {Query} from '../../../../responses/response'

//const config = refsConfig.filter(conf => !['work-object', 'task-type'].includes(conf.key))
const config = refsConfig.filter(conf => !['work_object', 'tasks_type'].includes(conf.key))

const SearchFilters: FunctionComponent = () => {
    const dispatch = useRootDispatch()
    const filters = useRootSelector(state => state.pages.search.filters)
    const total = useRootSelector(state => state.pages.search.total)
    const [open, setOpen] = useState(false)

    const active = isDefinedRecord(filters.dropdowns) || isDefinedTuple(filters.openedAt)

    const requestTasks = ({search, ...rest}: Query) => apiRequests.project.tip({
        params: {key: 'tasks_type'},
        query: {query: search, ...rest}
    })
    const requestWorkObjects = ({search, ...rest}: Query) => apiRequests.project.tip({
        params: {key: 'work_object'},
        query: {query: search, ...rest}
    })

    return <div className={styles.filters}>
        <div className={styles.row}>
            <div className={Classes.f11}>Показано объектов: <span className={Classes.f13b}>{total}</span></div>
            <Spacer/>
            <Field
                className={styles.search}
                type={'text'}
                value={filters.search}
                onChange={search => dispatch(searchActions.updateFilters({search}))}
                placeholder={'Поиск объекта'}
                rightItem={<SearchIcon/>}
            />
            <Splitter/>
            <RequestDropdown<RefIntersection>
                className={styles.mxw200}
                type={'multi'}
                request={requestTasks}
                render={type => type.name}
                placeholder={'Тип задач'}
                //value={Array.isArray(filters.dropdowns.tasks_type)? []: (filters.dropdowns.tasks_type ?? [])}
                value={Array.isArray(filters.dropdowns.tasks_type)? (filters.dropdowns.tasks_type ?? []): []}
                onChange={value => dispatch(searchActions.updateFilters({dropdowns: {
                    ...filters.dropdowns, tasks_type: value ?? null
                }}))}
            />
            <Splitter/>
            <RequestDropdown<RefIntersection>
                className={styles.mxw200}
                type={'multi'}
                request={requestWorkObjects}
                render={object => object.name}
                //render={object => object.work_object?.name + ' (' + object.name + ')'}
                placeholder={'Вид объекта'}
                //value={Array.isArray(filters.dropdowns.work_object)? undefined: (filters.dropdowns.work_object ?? undefined)}
                value={Array.isArray(filters.dropdowns.work_object)? (filters.dropdowns.work_object ?? []): []}
                onChange={value => dispatch(searchActions.updateFilters({dropdowns: {
                    ...filters.dropdowns, work_object: value ?? null
                }}))}
            />
            <Splitter/>
            <Button
                title={open ? 'Скрыть фильтры' : 'Показать фильтры'}
                buttonStyle={active ? ButtonStyle.DEFAULT : ButtonStyle.TINTED}
                active={active || open}
                onClick={() => setOpen(!open)}
            >
                <FiltersIcon/>
            </Button>
            <Button
                title={'Очистить фильтры'}
                onClick={() => dispatch(searchActions.clearFilters())}
            >
                <FiltersClearIcon/>
            </Button>
        </div>
        <PopupFilters open={open} filters={filters} config={config} onChange={flow(searchActions.updateFilters, dispatch)} objectStatusFilters={true}/>
    </div>
}

export default SearchFilters